export const enClientPortalHandoverApprovalStatusActions = {
    handover: {
        chipLabel: 'Comments shared',
        sharedByTooltip: 'shared by {{user}}',
        sharedOn: 'Shared on {{date}}',
        shared: 'shared',
        actionDescription: 'Send comments to the appraiser and request a new draft.',
    },
    approval: {
        approvedOn: 'approved on {{date}}',
        approved: 'approved',
        openApprovalDescription: 'Approve the draft and request finalisation.',
    },
}
